<div class="mt-img-effect mt-img-overlay7">
    <img src="{{data.image}}" alt="">
</div>
<div class="mt-info p-a30">
    <h4 class="m-b10 m-t0"><a routerLink="/project-grid">{{data.title}}</a></h4>
    <p>{{data.description}}</p>
    <a routerLink="/project-grid" class="site-button btn-effect">Read More</a>
</div>